/*
 * @providesModule WithdrawalStyle
 *
 */

import {Platform, StyleSheet} from 'react-native';
import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';
import SKZConstants from 'SKZConstants';

const {
  fontRegular,
  fontSecondary,
  fontSizeH4,
  fontSizeH5,
  fontSizeH3,
  fontMedium,
  fontBold,
  viewCornerRadiusSecondary,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  navbar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 2,
  },

  landscapeAndTabletBG: {
    flex: 1,
  },

  container: {
    flex: 1,
    backgroundColor: '#FFF',
  },

  landscapePhoneContainer: {
    flex: 1,
    width: 374,
    marginTop: 22,
    backgroundColor: '#FFF',
    borderTopLeftRadius: viewCornerRadiusSecondary.borderRadius,
    borderTopRightRadius: viewCornerRadiusSecondary.borderRadius,
    alignSelf: 'center',
    overflow: 'hidden',
  },

  tabletContainer: {
    flex: 1,
    width: SKZConstants.TABLET_USABLE_AREA_WIDTH_PERCENT,
    marginVertical: 60,
    alignSelf: 'center',
    borderRadius: viewCornerRadiusSecondary.borderRadius,
    backgroundColor: '#FFF',
    overflow: 'hidden',
  },

  contentContainer: {
    paddingTop: Sizes.select({
      tablet: 50,
      other: 22,
    }),
  },

  cancelWithdrawalContainer: {
    marginBottom: 24,
  },

  section: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: Sizes.select({
      tablet: 50,
      other: 24,
    }),
    marginBottom: Sizes.select({
      tablet: 50,
      other: 34,
    }),
  },

  verticalSection: {
    flexDirection: 'column',
  },

  sectionTitle: {
    marginBottom: 6,
  },

  lightText: {
    ...fontRegular,
    ...fontSizeH5,
    color: 'rgb(172, 172, 172)',
  },

  largeLightText: {
    ...fontRegular,
    ...fontSizeH4,
    color: 'rgb(172, 172, 172)',
  },

  sectionText: {
    ...fontRegular,
    ...fontSizeH4,
    color: 'rgb(77, 77, 77)',
    marginBottom: Platform.select({
      ios: 0,
      android: 2,
    }),
  },

  optionButton: {
    width: 72,
    height: 30,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    alignSelf: 'flex-end',
    marginLeft: 10,
  },

  addressError: {
    ...fontRegular,
    ...fontSizeH5,
    color: 'rgb(188, 33, 49)',
    marginTop: 4,
  },

  optionButtonText: {
    ...fontSizeH4,
    ...fontSecondary,
    color: 'rgb(74, 144, 226)',
  },

  tabsContainer: {
    width: 120,
    height: 30,
  },

  tab: {
    borderColor: 'rgb(74, 144, 226)',
    backgroundColor: '#FFF',
  },

  tabText: {
    ...fontSecondary,
    ...fontSizeH4,
    color: 'rgb(74, 144, 226)',
  },

  activeTab: {
    backgroundColor: 'rgb(74, 144, 226)',
  },

  activeTabText: {
    ...fontSecondary,
    ...fontSizeH4,
    color: '#FFF',
  },

  infoButton: {
    marginRight: 8,
    alignSelf: 'center',
  },

  infoIcon: {
    width: 25,
    height: 25,
    padding: 5,
  },

  infoModalTitle: {
    ...fontMedium,
    ...fontSizeH3,
    color: 'rgb(51, 51, 51)',
  },

  infoModalMessage: {
    ...fontRegular,
    ...fontSizeH4,
    color: 'rgb(51, 51, 51)',
  },

  modalTitle: {
    color: 'rgb(51, 51, 51)',
    ...fontSizeH3,
    ...fontMedium,
  },

  modalMessage: {
    color: 'rgb(51, 51, 51)',
    ...fontRegular,
    ...fontSizeH4,
  },

  withdrawalDetailsTitle: {
    ...fontBold,
    ...fontSizeH4,
    color: 'rgb(77, 77, 77)',
    paddingHorizontal: Sizes.select({
      tablet: 44,
      other: 24,
    }),
    marginBottom: 4,
  },

  withdrawalDetailsMessage: {
    ...fontRegular,
    ...fontSizeH5,
    color: 'rgb(77, 77, 77)',
    paddingHorizontal: Sizes.select({
      tablet: 44,
      other: 24,
    }),
  },

  detailsSection: {
    paddingTop: 20,
    paddingHorizontal: Sizes.select({
      tablet: 44,
      other: 24,
    }),
  },

  detailsSectionBottom: {
    backgroundColor: 'rgb(246, 246, 246)',
    paddingHorizontal: Sizes.select({
      tablet: 44,
      other: 24,
    }),
  },

  faqSupportSection: {
    backgroundColor: '#FFF',
    marginTop: Sizes.select({
      tablet: 12,
      other: 8,
    }),
    paddingVertical: 12,
    paddingHorizontal: Sizes.select({
      tablet: 44,
      other: 24,
    }),
  },

  faqSupportText: {
    fontSize: 12,
    ...fontRegular,
    color: '#333',
  },

  faqSupportLinkText: {
    fontSize: 12,
    ...fontRegular,
    color: '#367BCE',
  },

  detailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 14,
  },

  withdrawAmountText: {
    ...fontBold,
    ...fontSizeH3,
    color: 'rgb(98, 180, 57)',
  },

  footer: {
    height: 64,
    backgroundColor: '#FFF',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: 'rgb(219, 219, 219)',
  },

  nextButton: {
    alignSelf: 'center',
    width: 174,
    height: 34,
  },

  nextButtonText: {
    ...fontSizeH4,
    ...fontSecondary,
    color: '#FFF',
  },

  flexOne: {
    flex: 1,
  },

  errorModalContentContainer: {
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },

  errorBodyText: {
    ...fontSizeH4,
    ...fontRegular,
    color: '#333',
  },

  bannerContainer: {
    backgroundColor: 'rgb(188, 33, 49)',
    paddingVertical: 16,
    paddingHorizontal: 20,
  },

  bannerText: {
    ...fontRegular,
    ...fontSizeH4,
    color: '#FFF',
    textAlign: 'center',
  },

  confirmModalContent: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 12,
    marginHorizontal: 24,
    marginTop: 18,
    paddingVertical: 2,
  },

  bodyText: {
    ...fontSizeH4,
    ...fontRegular,
    color: '#333',
    textAlign: 'center',
  },

  confirmModalBonusText: {
    marginTop: 12,
  },
});
